var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPipedrive({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533.333,
    height: 533.333,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03363D",
    d: "M181.5 1C128.8 6.4 80.2 31.9 47.1 71.5-19 150.8-14.5 266.8 57.5 339.6c21.1 21.4 41.6 35.1 68.5 45.9 88.1 35.2 189.8 2.9 241.3-76.5 15.5-23.9 24.8-47.9 29.8-76.9 3.1-17.6 3.1-47.2 0-64.5-5.2-29.5-14.3-52.7-29.8-76.5-30.4-46.9-78.8-78.6-134.4-88C219.3.7 194.2-.2 181.5 1zm66.2 76.6c31.9 8.1 52.8 31.1 60.5 66.9 2 9.5 1.7 36.3-.6 46-4.2 18.3-11.3 31.4-23.5 43.6-13.4 13.4-27.9 20.6-46.5 23.1-9.7 1.3-24.8.5-33.1-1.7-8.8-2.3-19.3-7.8-24.7-13L175 238v88h-52l-.2-101.8-.3-101.7-10.2-.3-10.3-.3v-43l25.3.3c23.6.3 25.5.4 29.2 2.5 6.7 3.6 10.4 8.6 13.8 18.5.5 1.3 2.1.2 7.9-5.5 10.5-10.4 22.2-16.1 38.3-18.7 7.6-1.1 23.7-.4 31.2 1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03363D",
    d: "M208.6 119.2c-20.8 2.7-33.1 18.6-34.3 44.3-.6 12.5.8 20 5.7 30 4 8.3 8.8 13.6 15.7 17.2 20.5 11 46.3 2.3 56.3-18.9 4.2-8.8 5.3-15.5 4.8-28.3-.8-16.9-6.3-28.5-17.8-36.9-9.2-6.8-18.4-9-30.4-7.4z"
  })));
}

export default SvgPipedrive;